module.exports = __webpack_public_path__ + "img/p2p.png";